import { render } from "./ShipmentList.vue?vue&type=template&id=1d6c61c4&scoped=true"
import script from "./ShipmentList.vue?vue&type=script&lang=js"
export * from "./ShipmentList.vue?vue&type=script&lang=js"

import "./ShipmentList.vue?vue&type=style&index=0&id=1d6c61c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6c61c4"]])

export default __exports__